import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { formatNumber } from 'shared/utils';
import { Modal } from 'src/components/design-system';
import styles from './check-in.module.scss';

export function ConfirmFutureCheckInModal({
  open,
  daysFromNow,
  eventDate,
  loading,
  onCancel,
  onConfirm,
}) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));

  const messageText = (
    daysFromNow === 1
      ? lang.FUTURE_CHECK_IN_CONFIRM_MESSAGE_ONE
      : lang.FUTURE_CHECK_IN_CONFIRM_MESSAGE.replace('{days}', formatNumber(daysFromNow))
  ).replace('{date}', eventDate);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onSubmit={onConfirm}
      title={lang.FUTURE_CHECK_IN_CONFIRM_TITLE}
      cancelText={lang.FUTURE_CHECK_IN_CONFIRM_CANCEL}
      submitText={lang.FUTURE_CHECK_IN_CONFIRM_CONFIRM}
      loading={loading}
      width={420}>
      <p className={styles.futureCheckInMessage}>{messageText}</p>
    </Modal>
  );
}
